import { render } from "./ActionSendRCS.vue?vue&type=template&id=904ba994"
import script from "./ActionSendRCS.vue?vue&type=script&lang=ts"
export * from "./ActionSendRCS.vue?vue&type=script&lang=ts"
script.render = render

export default script